<style>
    .contacts-container {
        padding: 30px;
    }
</style>
<template>
    <el-card>    
        <div class="contacts-container">
            <el-tabs v-model="activeName">
                <template v-for="el in buttonConfig">
                    <el-tab-pane label="客户期间业务查询" name="khqjyw"  v-if="el.type == 'khqjyw'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定业务日期时间段">
                                <ly-date-picker width="220px" v-model="khqjywDateRange"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="月中日期">
                                <ly-date-picker
                                    v-model="khqjywDate"
                                    width="150px"
                                    type="date"
                                    placeholder="选择日期">
                                </ly-date-picker>
                            </el-form-item>
                            <!-- <el-form-item label="指定单据标记">
                                <ly-checkbox :data-list="danjubs_list" :is-all="true" :default-check="checkedCities" :type="2" v-model="khqjyw.danjubj_ids"  style="width:700px"></ly-checkbox>
                            </el-form-item> -->
                            <el-form-item label="核算维度">
                                <ly-checkbox :data-list="dimension_list" v-model="khqjyw.accounting_dimension_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="按业务员指定客户">
                                <ly-checkbox :data-list="customer_list" :is-all="true" v-model="khqjyw.employee_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <!-- <el-form-item label="指定货品类别">
                                <ly-checkbox :data-list="productType_list" :is-all="true" v-model="khqjyw.product_types" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item> -->
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isKhqjywShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isKhqjywShowCustomer" :thead-config="customerConfig" ref="khqjywCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item label="指定excel导出列">
                                <el-checkbox label="默认设置" name="type" v-model="isKhqjywShow"></el-checkbox>
                                <div style="width: 842px;" v-if="!isKhqjywShow">
                                    <ly-checkbox title="标准信息列" :data-list="excel_list" :is-all="true" v-model="khqjyw.config" default-check="all" style="width:700px;"></ly-checkbox>
                                    <ly-checkbox title="扩展信息列" :data-list="extension_list" :is-all="true" v-model="extension_ids" style="width:700px;"></ly-checkbox>
                                </div>
                            </el-form-item>
                            <el-form-item label="附件信息统计">
                                <ly-checkbox :data-list="attachment" v-model="khqjyw.is_fujia" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="去除无变动数据">
                                <ly-checkbox :data-list="attchange" v-model="khqjyw.is_xianshi" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="回款登记明细表" name="hkdjmx" v-if="el.type == 'hkdjmx'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="登记日期">
                                <ly-date-picker width="220px" v-model="hkdjmxDateRange"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="回款日期">
                                <ly-date-picker width="220px" v-model="hkdjmxDate"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="收款账户">
                                <ly-checkbox :data-list="paymentAccount_list" :is-all="true" v-model="hkdjmx.account_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isHkdjmxShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isHkdjmxShowCustomer" :thead-config="customerConfig" ref="hkdjmxCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="回款登记明细表(对账查询)" name="hkdjmxdz" v-if="el.type == 'hkdjmxdz'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="对账时间">
                                <ly-datetime-picker width="220px" v-model="hkdjmxdzDate"></ly-datetime-picker>
                            </el-form-item>
                            <el-form-item label="收款账户">
                                <ly-checkbox :data-list="paymentAccount_list" :is-all="true" v-model="hkdjmxdz.account_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isHkdjmxdzShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isHkdjmxdzShowCustomer" :thead-config="customerConfig" ref="hkdjmxdzCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="回款确认明细表" name="hkqrmx" v-if="el.type == 'hkqrmx'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定交易日期时间段">
                                <ly-date-picker width="220px" v-model="hkqrmxDateRange"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="收款账户">
                                <ly-checkbox :data-list="paymentAccount_list" :is-all="true" v-model="hkqrmx.account_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isHkqrmxShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isHkqrmxShowCustomer" :thead-config="customerConfig" ref="hkqrmxCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="其他收付明细表" name="qtsfmx" v-if="el.type == 'qitasf'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定时间段">
                                <ly-date-picker width="220px" v-model="qtsfmxDateRange"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="核算维度">
                                <ly-checkbox :data-list="dimension_list" :is-all="true" v-model="qtsfmx.accounting_dimension_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isQtsfmxShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isQtsfmxShowCustomer" :thead-config="customerConfig" ref="qtsfmxCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item label="指定往来项目">
                                <el-checkbox label="全部" name="type" v-model="isQtsfShowWlxm"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isQtsfShowWlxm" :thead-config="wanglaiConfig" ref="qtsfWanglai"></ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item label="指定品牌">
                                <ly-checkbox :data-list="productbrands" :is-all="true" default-check="all" v-model="qtsfmx.product_brand" style="width:700px"></ly-checkbox>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="其他收付汇总表" name="qtsfhz" v-if="el.type == 'qitasf_hz'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定时间段">
                                <ly-date-picker width="220px" v-model="qtsfhzDateRange"></ly-date-picker>
                            </el-form-item>
                            <el-form-item label="报表汇总方式">  
                                <el-radio v-model="qtsfhz.baobiao_type" label="1">按维度汇总</el-radio>
                                <el-radio v-model="qtsfhz.baobiao_type" label="2">按维度+单据业务员汇总</el-radio>
                            </el-form-item>
                            <el-form-item label="核算维度">
                                <ly-checkbox :data-list="dimension_list" :is-all="true" v-model="qtsfhz.accounting_dimension_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="按业务员指定客户">
                                <ly-checkbox :data-list="customer_list" :is-all="true" v-model="qtsfhz.employee_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isQtsfhzShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isQtsfhzShowCustomer" :thead-config="customerConfig" ref="qtsfhzCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item label="指定往来项目">
                                <el-checkbox label="全部" name="type" v-model="isQtsfhzShowWlxm"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isQtsfhzShowWlxm" :thead-config="wanglaiConfig" ref="qtsfhzWanglai"></ly-product-table>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="客户期间业务报表" name="khqjywbb"  v-if="el.type == 'khqjywbb'">
                        <el-form :label-width="labelWidth">
                            <el-form-item label="指定业务日期时间段">
                                <ly-date-picker width="220px" v-model="khqjywbbDateRange"></ly-date-picker>
                            </el-form-item>
                            <!--<el-form-item label="月中日期">
                                <ly-date-picker
                                    v-model="khqjywbbDate"
                                    width="150px"
                                    type="date"
                                    placeholder="选择日期">
                                </ly-date-picker>
                            </el-form-item>-->
                            <!-- <el-form-item label="指定单据标记">
                                <ly-checkbox :data-list="danjubs_list" :is-all="true" :default-check="checkedCities" :type="2" v-model="khqjyw.danjubj_ids"  style="width:700px"></ly-checkbox>
                            </el-form-item> -->
                            <el-form-item label="核算维度">
                                <ly-checkbox :data-list="dimension_list" v-model="khqjywbb.accounting_dimension_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <el-form-item label="按业务员指定客户">
                                <ly-checkbox :data-list="customer_list" :is-all="true" v-model="khqjywbb.employee_ids" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                            <!-- <el-form-item label="指定货品类别">
                                <ly-checkbox :data-list="productType_list" :is-all="true" v-model="khqjyw.product_types" default-check="all" style="width:700px;"></ly-checkbox>
                            </el-form-item> -->
                            <el-form-item label="指定个别客户">
                                <el-checkbox label="全部" name="type" v-model="isKhqjywbbShowCustomer"></el-checkbox>
                                <div style="width: 842px;">
                                    <ly-product-table v-if="!isKhqjywbbShowCustomer" :thead-config="customerConfig" ref="khqjywbbCustomer"></ly-product-table>
                                </div>
                            </el-form-item>
                            <el-form-item label="指定excel导出列">
                                <el-checkbox label="默认设置" name="type" v-model="isKhqjywbbShow"></el-checkbox>
                                <div style="width: 842px;" v-if="!isKhqjywbbShow">
                                    <ly-checkbox title="标准信息列" :data-list="excel_list" :is-all="true" v-model="khqjywbb.config" default-check="all" style="width:700px;"></ly-checkbox>
                                    <ly-checkbox title="扩展信息列" :data-list="extension_list" :is-all="true" v-model="extensionbb_ids" style="width:700px;"></ly-checkbox>
                                </div>
                            </el-form-item>
                            <!--<el-form-item label="附件信息统计">
                                <ly-checkbox :data-list="attachment" v-model="khqjywbb.is_fujia" style="width:700px;"></ly-checkbox>
                            </el-form-item>-->
                            <el-form-item label="去除无变动数据">
                                <ly-checkbox :data-list="attchange" v-model="khqjywbb.is_xianshi" style="width:700px;"></ly-checkbox>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </template>
            </el-tabs>
            <!--底部提交按钮-->
            <el-form :label-width="labelWidth">
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">提交查询</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-card>
</template>
<script>
    /**
     * 往来查询
     * @author wxq
     * @time 2018.5.16
     */
    import LyDatePicker from '@c/date_picker'
    import LySelect from '@c/select'
    import LyBatch from '@c/batch'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyCheckbox from '@c/checkbox'
    import Contacts from './Contacts'
    import LyDatetimePicker from '@c/datetime-picker'
    export default {
        mixins: [Contacts],
        components: {
            LyDatePicker,
            LySearchForm,
            LySelect, 
            LyBatch,
            LyProductTable,
            LyCheckbox,
            LyDatetimePicker
        },
        data () {
            return {
                activeName: 'khqjyw',
                labelWidth: '120px', // 标题宽度，统一设置为了以后方便调整
                khqjywDateRange: "", // 客户期间业务查询时间段
                khqjywDate: "", // 月中日期
                khqjywbbDateRange: "", // 客户期间业务查询时间段
                khqjywbbDate: "", // 月中日期
                hkdjmxDateRange: "",
                hkdjmxDate: "",
                sblphzDateRange: "", // 三包理赔汇总查询时间段
                hkqrmxDateRange: "", // 回款确认明细表时间段
                qtsfmxDateRange: "", // 其他收付明细表时间段
                qtsfhzDateRange: "", // 其他收付汇总表时间段
                buttonConfig: {}, // tab按钮的配置
                hkdjmxdzDate: "", // 回款登记明细表（对账查询）
                // checkedCities: [],
                // danjubs_list: [], // 单据标识列表
                // productType_list: [{
                //     id: 1,
                //     name: '轮胎类'
                // },{
                //     id: 2,
                //     name: '汽配类'
                // },{
                //     id: 3,
                //     name:'礼品/其他类'
                // },{
                //     id: 4,
                //     name: '服务/劳务/虚拟类'
                // }], // 货品类别
                paymentAccount_list: [], // 收款账户
                dimension_list: [], // 核算维度
                customer_list: [], // 客户列表
                productbrands: [], // 品牌列表
                excel_list: [{
                    name: "客户编码",
                    id: "客户编码"
                },{
                    name: "客户名称",
                    id: "客户名称"
                },{
                    name: "所属业务员",
                    id: "所属业务员"
                },{
                    name: "业务线",
                    id: "业务线"
                },{
                    name: "信用额度",
                    id: "信用额度"
                },{
                    name: "核算维度",
                    id: "核算维度"
                },{
                    name: "期初金额",
                    id: "期初金额"
                },{
                    name: "销售开票",
                    id: "销售开票"
                },{
                    name: "退货",
                    id: "退货"
                },{
                    name: "三包开票",
                    id: "三包开票"
                },{
                    name: "三包理赔",
                    id: "三包理赔"
                },{
                    name: "贴损金额",
                    id: "贴损金额"
                },{
                    name: "冲抵返利",
                    id: "冲抵返利"
                },{
                    name: "开票折扣",
                    id: "开票折扣"
                },{
                    name: "运费",
                    id: "运费"
                },{
                    name: "现金回款",
                    id: "现金回款"
                },{
                    name: "现金退款",
                    id: "现金退款"
                },{
                    name: "银行回款",
                    id: "银行回款"
                },{
                    name: "银行退款",
                    id: "银行退款"
                },{
                    name: "银行承兑汇票",
                    id: "银行承兑汇票"
                },{
                    name: "其他收付",
                    id: "其他收付"
                },{
                    name: "赠送返利",
                    id: "赠送返利"
                },{
                    name: "赠送开票",
                    id: "赠送开票"
                },{
                    name: "期末余额",
                    id: "期末余额"
                },{
                    name: "礼品开票",
                    id: "礼品开票"
                },{
                    name: "礼品返利",
                    id: "礼品返利"
                }],
                extension_list: [{
                    name: "销售开票成本",
                    id: "销售开票成本"
                },{
                    name: "退货成本",
                    id: "退货成本"
                },{
                    name: "三包开票成本",
                    id: "三包开票成本"
                },{
                    name: "赠送开票成本",
                    id: "赠送开票成本"
                },{
                    name: "礼品开票成本",
                    id: "礼品开票成本"
                },{
                    name: "月中余额",
                    id: "月中余额"
                }],
                extension_ids: [],
                extensionbb_ids: [],
                attachment: [{
                    name: "显示附加信息(按标签统计信息)",
                    id:1
                }], // 附件信息统计
                attchange: [{
                    name: "不显示本期客户无变动数据",
                    id:1
                }], // 去除无变动数据
                khqjyw: {
                    ticket: "khqjyw",
                    date_start: "",
                    date_end: "",
                    yuezhong_time: "",  
                    // danjubj_ids: [], // 单据标识数组      
                    accounting_dimension_ids: [], // 核算维度数组
                    employee_ids: [], // 按业务员指定客户数组  
                    // product_types: [], // 货品类别数组   
                    customer_ids: [], // 指定客户
                    config: [], // excel项
                    is_fujia:[], // 附件信息
                    is_xianshi:[] // 去除无变动数据
                },
                khqjywbb: {
                    ticket: "khqjywbb",
                    date_start: "",
                    date_end: "",
                    yuezhong_time: "",  
                    // danjubj_ids: [], // 单据标识数组      
                    accounting_dimension_ids: [], // 核算维度数组
                    employee_ids: [], // 按业务员指定客户数组  
                    // product_types: [], // 货品类别数组   
                    customer_ids: [], // 指定客户
                    config: [], // excel项
                    is_fujia:[], // 附件信息
                    is_xianshi:[] // 去除无变动数据
                },
                hkdjmx: {
                    ticket: 'huikuandjmx',
                    date_registration_start: "",
                    date_registration_end: "",
                    date_returned_start: "",
                    date_returned_end: "",
                    account_ids: [],
                    customer_ids:[]
                },
                submitdata: {
                    page: 1,
                    size: 100,
                    route: "bankaccount",
                    jingying_tb: "all"
                },// 收款账户请求数据
                isKhqjywShowCustomer: true, // 控制客户期间业务指定个别客户的全选与否
                isKhqjywbbShowCustomer: true, // 控制客户期间业务指定个别客户的全选与否
                isHkdjmxShowCustomer: true, // 控制汇款登记明细指定个别客户的全选与否
                isHkdjmxdzShowCustomer: true,
                isHkqrmxShowCustomer: true,
                isQtsfmxShowCustomer: true,
                isQtsfhzShowCustomer: true,
                isKhqjywShow: true, // 控制excel列的显示
                isKhqjywbbShow: true, // 控制excel列的显示
                isQtsfShowWlxm: true, // 其他收付
                isQtsfhzShowWlxm: true, // 指定往来项目
                hkdjmxdz: {
                    ticket: 'hkdjdzmx',
                    duizhang_time_start: '',
                    duizhang_time_end: '',
                    account_ids: [], // 收款账户
                    customer_ids:[] // 指定客户
                },
                hkqrmx: {
                    ticket: "hkqrmx",
                    date_start: "",
                    date_end: "",
                    account_ids: [], // 收款账户
                    customer_ids:[] // 指定客户
                },
                qtsfmx: {
                    ticket: "qitasf",
                    date_start: "",
                    date_end: "",
                    accounting_dimension_ids: [], // 核算维度数组
                    customer_ids: [], // 指定客户
                    product_ids: [],
                    product_brand:[]
                },
                qtsfhz: {
                    ticket: "qitasf_hz",
                    date_start: "",
                    date_end: "",
                    baobiao_type: '1', // 报表汇总方式
                    employee_ids: [],
                    accounting_dimension_ids: [],
                    customer_ids: [], // 指定客户
                    product_ids: []
                }
            }
        },
        watch: {
            'khqjywDateRange' (v) {
                this.khqjyw.date_start = v.split("~")[0];
                this.khqjyw.date_end = v.split("~")[1];
            },
            'khqjywbbDateRange' (v) {
                this.khqjywbb.date_start = v.split("~")[0];
                this.khqjywbb.date_end = v.split("~")[1];
            },
            'khqjywDate' (v) {
                this.khqjyw.yuezhong_time = v;
            },
            'khqjywbbDate' (v) {
                this.khqjywbb.yuezhong_time = v;
            },
            'hkdjmxDateRange' (v) {
                this.hkdjmx.date_registration_start = v.split("~")[0];
                this.hkdjmx.date_registration_end = v.split("~")[1];
            },
            'hkdjmxDate' (v) {
                this.hkdjmx.date_returned_start = v.split("~")[0];
                this.hkdjmx.date_returned_end = v.split("~")[1]
            },
            'hkdjmxdzDate' (v) {
                this.hkdjmxdz.duizhang_time_start = v.split("~")[0]
                this.hkdjmxdz.duizhang_time_end = v.split("~")[1]
            },
            'hkqrmxDateRange' (v) {
                this.hkqrmx.date_start = v.split("~")[0]
                this.hkqrmx.date_end = v.split("~")[1]
            },
            'qtsfmxDateRange' (v) {
                this.qtsfmx.date_start = v.split("~")[0]
                this.qtsfmx.date_end = v.split("~")[1]
            },
            'qtsfhzDateRange' (v) {
                this.qtsfhz.date_start = v.split("~")[0]
                this.qtsfhz.date_end = v.split("~")[1]
            }
        },
        created () {
            this.readRouteConfig()
        },
        mounted () {
            let khqjywStandard = window.localStorage.getItem('khqjyw_standard')
            let khqjywExtend = window.localStorage.getItem('khqjyw_extend')
            if (khqjywStandard || khqjywExtend) {
                this.isKhqjywShow = false
                this.khqjyw.config = khqjywStandard.split(",")
                this.extension_ids = khqjywExtend.split(",")
            }
            let khqjywbbStandard = window.localStorage.getItem('khqjywbb_standard')
            let khqjywbbExtend = window.localStorage.getItem('khqjywbb_extend')
            if (khqjywbbStandard || khqjywbbExtend) {
                this.isKhqjywbbShow = false
                this.khqjywbb.config = khqjywbbStandard.split(",")
                this.extensionbb_ids = khqjywbbExtend.split(",")
            }
            // 初始化指定时间段，默认为当天
            var today = this.$utils.dateFormat('yyyy-MM-dd',new Date())
            this.khqjywDateRange = today + "~" + today
            this.khqjywDate = today
            this.khqjywbbDateRange = today + "~" + today
            this.khqjywbbDate = today
            this.hkdjmxDateRange = today + "~" + today
            this.hkdjmxDate = today + "~" + today
            this.hkqrmxDateRange = today + "~" + today
            this.qtsfmxDateRange = today + "~" + today
            this.qtsfhzDateRange = today + "~" + today
            // this.querydanjubj();
            this.querycustomer();
            this.queryaccountingDimension();
            this.querybankaccount();
            this.queryBrand();
        },
        methods: {
            /**
            * 获取收款账户
            */
            querybankaccount () {
                this.$api.bankaccount.query(this.submitdata).then((rs) => {
                    // 删除最后一个元素（总计）
                    if (rs.data && rs.data.length > 0) {
                         rs.data.pop()
                    }
                    // for (var i = 0; i < rs.data.length; i++) {
                    //     rs.data[i]['name'] = rs.data[i].account_name;
                    // } // 给数据加上name属性
                    rs.data.map((item) => {
                        item['name'] = item.account_name;
                    })
                    this.paymentAccount_list = rs.data;
                    rs.data.map((item) => {
                        this.hkdjmx.account_ids.push(item.id)
                        this.hkdjmxdz.account_ids.push(item.id)
                        this.hkqrmx.account_ids.push(item.id)
                    });
                })
            },
            /**
            * 获取或品牌列表
            */
            queryBrand () {
                this.$api.productbrand.query().then((rs) => { // 正确请求成功时处理  
                    this.productbrands = rs;
                    // 把获取的货品品牌的id单独出来成数组
                    rs.map((item) => {
                        this.qtsfmx.product_brand.push(item.id);
                    });
                })
            },
            /**
            * 获取单据标记
            */
            // querydanjubj () {
            //     this.$api.query('api/danjubj',{type: 1}).then((rs) => {
            //         this.danjubs_list = rs;
            //         // 把获取的单据标记的id单独出来成数组
            //         rs.map((item) => {
            //             if (item.name === '正常' || item.name === '调账' || item.name === '冲抵返利' || item.name === '特价处理') { // 初始化默认选中项的id
            //                 this.khqjyw.danjubj_ids.push(item.id);
            //             }
            //         });
            //     })
            // },
            /**
            * 获取客户列表
            */
            querycustomer () {
                this.$api.query('api/employee').then((rs) => {
                    for (var i = 0; i < rs.length; i++) {
                        rs[i]['id'] = rs[i].value;
                        rs[i]['name'] = rs[i].label;
                    } // 给数据加上id和name属性
                    this.customer_list = rs;
                    // 把获取的客户的id单独出来成数组
                    rs.map((item) => {
                        this.khqjyw.employee_ids.push(item.id);
                        this.khqjywbb.employee_ids.push(item.id);
                        this.qtsfhz.employee_ids.push(item.id);
                    });
                })
            },
            /**
            * 获取核算维度
            */
            queryaccountingDimension () {
                this.$api.accountingDimension.query().then((rs) => {
                    for (var i = 0; i < rs.length; i++) {
                        rs[i]['id'] = rs[i].value;
                        rs[i]['name'] = rs[i].label;
                    } // 给数据加上id和name属性
                    this.dimension_list = rs;
                    // 把获取的客户的id单独出来成数组
                    rs.map((item) => {
                        this.khqjyw.accounting_dimension_ids.push(item.id);
                        this.khqjywbb.accounting_dimension_ids.push(item.id);
                        this.qtsfmx.accounting_dimension_ids.push(item.id);
                        this.qtsfhz.accounting_dimension_ids.push(item.id);
                    });
                })
            },
            /**
             * 提交查询
             */
            onSubmit () {   
                // 根据不同的tab，设置上传数据
                switch (this.activeName) {
                    case "khqjyw": 
                        let customerIds = []; 
                        if (Object.is(this.isKhqjywShowCustomer,false)) {  
                            // 获取已选数据的id集合
                            customerIds = this.$refs['khqjywCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerIds = Array.from(new Set(customerIds)); 
                        } 
                        this.khqjyw.customer_ids = customerIds // 获取客户列表
                        if (!this.isKhqjywShow) {
                            let standard = this.khqjyw.config // 标准信息列
                            let extend = this.extension_ids // 扩展信息列
                            console.log("standard", standard)
                            window.localStorage.setItem('khqjyw_standard', standard) // 标准列
                            window.localStorage.setItem('khqjyw_extend', extend) // 扩展列
                            if (this.extension_ids && this.extension_ids.length > 0) {
                                this.mergeArray(this.khqjyw.config, this.extension_ids)
                            }
                        } else {
                            window.localStorage.removeItem('khqjyw_standard') // 清楚缓存数据
                            window.localStorage.removeItem('khqjyw_extend') // 清楚缓存数据
                            this.excel_list.map((item) => {
                                this.khqjyw.config.push(item.id);
                            });
                        }
                        this.formdata = this.khqjyw
                        break;
                    case "khqjywbb": 
                        let customerbbIds = []; 
                        if (Object.is(this.isKhqjywbbShowCustomer,false)) {  
                            // 获取已选数据的id集合
                            customerbbIds = this.$refs['khqjywbbCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerbbIds = Array.from(new Set(customerbbIds)); 
                        } 
                        this.khqjywbb.customer_ids = customerbbIds // 获取客户列表
                        if (!this.isKhqjywbbShow) {
                            let standard = this.khqjywbb.config // 标准信息列
                            let extend = this.extensionbb_ids // 扩展信息列
                            console.log("standard", standard)
                            window.localStorage.setItem('khqjywbb_standard', standard) // 标准列
                            window.localStorage.setItem('khqjywbb_extend', extend) // 扩展列
                            if (this.extension_ids && this.extension_ids.length > 0) {
                                this.mergeArray(this.khqjyw.config, this.extension_ids)
                            }
                        } else {
                            window.localStorage.removeItem('khqjywbb_standard') // 清楚缓存数据
                            window.localStorage.removeItem('khqjywbb_extend') // 清楚缓存数据
                            this.excel_list.map((item) => {
                                this.khqjywbb.config.push(item.id);
                            });
                        }
                        this.formdata = this.khqjywbb
                        break;
                    case "hkdjmx": 
                        let customerLds = [] 
                        if (Object.is(this.isHkdjmxShowCustomer,false)) {  
                            // 获取已选数据的id集合
                            customerLds = this.$refs['hkdjmxCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerLds = Array.from(new Set(customerLds)); 
                        } 
                        this.hkdjmx.customer_ids = customerLds; // 获取客户列表
                        this.formdata = this.hkdjmx;
                        break;
                    case 'hkdjmxdz':                    
                        let customerIdsxx = []
                        if (Object.is(this.isHkdjmxdzShowCustomer,false)) {
                            // 获取已选数据的id集合
                            customerIdsxx = this.$refs['hkdjmxdzCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerIdsxx = Array.from(new Set(customerIdsxx)); 
                        } 
                        this.hkdjmxdz.customer_ids = customerIdsxx; // 获取客户列表
                        this.formdata = this.hkdjmxdz;
                        break;  
                    case 'hkqrmx':
                        let customerIdshk = []
                        if (Object.is(this.isHkqrmxShowCustomer,false)) {
                            // 获取已选数据的id集合
                            customerIdshk = this.$refs['hkqrmxCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerIdshk = Array.from(new Set(customerIdshk)); 
                        } 
                        this.hkqrmx.customer_ids = customerIdshk; // 获取客户列表
                        this.formdata = this.hkqrmx;
                        break;
                    case 'qtsfmx':
                        let customerIdsqt = []
                        let wanglaiIdsqt = []
                        if (Object.is(this.isQtsfmxShowCustomer,false)) {
                            // 获取已选数据的id集合
                            customerIdsqt = this.$refs['qtsfmxCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerIdsqt = Array.from(new Set(customerIdsqt)); 
                        } 
                        if (Object.is(this.isQtsfShowWlxm,false)) {
                            // 获取已选数据的id集合
                            wanglaiIdsqt = this.$refs['qtsfWanglai'][0].getProductData().map((item) => {
                                return item.product.product_id   
                            });
                            // 数组去重
                            wanglaiIdsqt = Array.from(new Set(wanglaiIdsqt)); 
                        } 
                        this.qtsfmx.customer_ids = customerIdsqt; // 获取客户列表
                        this.qtsfmx.product_ids = wanglaiIdsqt;
                        this.formdata = this.qtsfmx;
                        break;
                    case 'qtsfhz':
                        let customerIdsqthz = []
                        let wanglaiIdsqthz = []
                        if (Object.is(this.isQtsfhzShowCustomer,false)) {
                            // 获取已选数据的id集合
                            customerIdsqthz = this.$refs['qtsfhzCustomer'][0].getProductData().map((item) => {
                                return item.customer.customer_id   
                            });
                            // 数组去重
                            customerIdsqthz = Array.from(new Set(customerIdsqthz)); 
                        } 
                        if (Object.is(this.isQtsfhzShowWlxm,false)) {
                            // 获取已选数据的id集合
                            wanglaiIdsqthz = this.$refs['qtsfhzWanglai'][0].getProductData().map((item) => {
                                return item.product.product_id
                            });
                            // 数组去重
                            wanglaiIdsqthz = Array.from(new Set(wanglaiIdsqthz)); 
                        } 
                        this.qtsfhz.customer_ids = customerIdsqthz; // 获取客户列表
                        this.qtsfhz.product_ids = wanglaiIdsqthz; // 获取往来项目
                        this.formdata = this.qtsfhz;
                        break;
                }
                if (this.activeName === 'khqjyw') {
                    var start = this.formdata.date_start + ' 0:00:00'
                    var end = this.formdata.date_end + ' 23:59:59'
                    var enter = this.formdata.yuezhong_time + ' 0:00:00'
                    if (Date.parse(enter) < Date.parse(start) || Date.parse(this.formdata.yuezhong_time) > Date.parse(end)) {
                        this.$message('月中日期需在指定时间段，请检查确认！')
                        return
                    }
                }     
                if (this.activeName === 'khqjywbb') {
                    /* var startbb = this.formdata.date_start + ' 0:00:00'
                    var endbb = this.formdata.date_end + ' 23:59:59'
                    var enterbb = this.formdata.yuezhong_time + ' 0:00:00' */
                    /* if (Date.parse(enterbb) < Date.parse(startbb) || Date.parse(this.formdata.yuezhong_time) > Date.parse(endbb)) {
                        this.$message('月中日期需在指定时间段，请检查确认！')
                        return
                    } */
                    // 请求扎帐接口 start
                    /**
                    * 等待扎帐接口 这里查询扎帐接口返回是true 则继续执行下去  返回是false 直接return出去就可以了  其余注意的就冉永红这边定义的activeName
                    */
                    // 请求扎帐接口 end
                }     
                // 调用接口
                this.$api.export.create(this.formdata).then((rs) => { // 正确请求成功时处理  
                    this.$alert('查询任务已提交，请前往查询下载中心下载计算完毕的数据', '提示信息', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        showCancelButton: true,
                        type: 'success'
                    }).then(() => {
                        this.$router.push('/download/three')
                    }, () => {})
                }).catch((error) => { // 捕捉错误处理  
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            /**
             * 读取当前页面的路有配置
             */
            readRouteConfig () {
                // 获得当前页面的配置
                let routeConfig = this.$utils.readRouteConfig(this.$route.fullPath)
                // 获得tab的配置
                if (routeConfig && routeConfig.page && routeConfig.page.length > 0) {
                    let config = routeConfig.page[0]['config']
                    if (typeof config.buttons === 'string') {
                        config.buttons = JSON.parse(config.buttons)
                    }
                    this.buttonConfig = config.buttons || []
                    // 设置默认的activeName 
                    if (this.buttonConfig.length > 0) {
                        this.activeName = this.buttonConfig[0]['type']
                    }
                }
            },
            /**
            * 数组合并并且去重
            */
            mergeArray (arr1, arr2) { 
                for (var i = 0; i < arr1.length; i++) {
                    for (var j = 0; j < arr2.length; j++) {
                        if (arr1[i] === arr2[j]) {
                            arr1.splice(i, 1); // 利用splice函数删除元素，从第i个位置，截取长度为1的元素
                        }
                    }
                }
                for (var k = 0; k < arr2.length; k++) {
                    arr1.push(arr2[k])
                }
                return arr1
            }
        }
    }
</script>